<script lang="ts">
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";
  import { lunchModal } from '../../../stores/lunch';

  export let request_store_key: StoresKey;
  export let buttonClass: string = 'btn-primary'; // Default to primary if not specified
  
  // Get store data
  const { store, T } = getStoresContext(request_store_key);
  
  // Open the lunch modal when button is clicked
  function openLunchModal() {
    if ($store) {
      lunchModal.open(request_store_key, $store.id);
    }
  }
</script>

{#if $store?.hasLunchMenu}
  <div class="lunch-button-wrapper">
    <button 
      class="btn {buttonClass}" 
      on:click={openLunchModal}
      type="button"
    >
      {$T('common.lunch-list')}
    </button>
  </div>
{/if}